import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
    selector: 'app-multi-select-box',
    templateUrl: './multi-select-box.component.html',
    styleUrls: ['./multi-select-box.component.scss'],
})
export class MultiSelectBoxComponent<T extends { name?: string | undefined }> {
    _selected: boolean[] | null | undefined
    _allSelected = false

    @Input()
    title: string | undefined
    @Input()
    showSelectAll: boolean | undefined = true

    private _items: T[] | null | undefined
    get items(): T[] | null | undefined {
        return this._items
    }
    @Input()
    set items(value: T[] | null | undefined) {
        this._items = value
        this._selected = value?.map(() => false)
    }

    @Output() selected = new EventEmitter<T[]>()

    change(index: number): void {
        if (this._allSelected) this._allSelected = false
        if (this._selected) {
            this._selected[index] = !this._selected[index]
            this.updateSelectedOutput()
        }
    }

    toggleAll(): void {
        this._allSelected = !this._allSelected
        if (this._selected) {
            this._selected.fill(this._allSelected)
            this.updateSelectedOutput()
        }
    }

    private updateSelectedOutput(): void {
        if (this._items) {
            this.selected.emit(this._items.filter((_item, index) => this._selected?.[index]))
        }
    }
}
